import axios from '../utils/axios'
const API_URL = process.env.REACT_APP_API_URL + "/v1/client/";


const getAssetDirectory = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/assets")
}
const getResources = (clinicId)=>{
    return axios.get(API_URL+"clinics/"+clinicId+"/resources")
}

const getDetails = (clinicId) =>{
    return axios.get(API_URL+"clinics/"+clinicId+"/resources/details")
}
const deleteMedia=(clinicid,data)=>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/resources",{data:data})
}
const uploadMedia=(clinicid,formData,uploadProgress)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/resources",formData,{
     headers:{
         'Content-Type': 'multipart/form-data',
     },
     onUploadProgress: uploadProgress,
    })
}
const renameMedia = (clinicId,data) =>{
    return axios.put(API_URL+"clinics/"+clinicId+"/resources/"+data.resourceId,data)
}
export default {
    getAssetDirectory,
    getResources,
    getDetails,
    deleteMedia,
    uploadMedia,
    renameMedia
}